/**
 *
 * AddressTypeCheckbox
 *
 */

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { IntlPropType } from "root/libs/core-libs/src";
import { TYPES_OF_ADDRESSES } from "one-time-shipment/src/containers/GetQuote/constants";
import { DhlCheckbox } from "@dhl-official/react-library";
import { Sizes } from "@dhl-official/stencil-library";

const StyledAddressTypeWrapper = styled.div`
  margin-top: ${({ hasPostcodesEnabled }) =>
    hasPostcodesEnabled ? "var(--dui-size-space-12x)" : "0"};

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin: var(--gaq-size-space-25px) var(--gaq-size-space-5px) 0 0;
  }

  & > label > input {
    /*! @noflip */
    left: -9999px;
    /*! @noflip */
    right: unset;
    position: absolute;
  }
`;

const COPY_ID_PREFIX = "AddressTypeCheckbox";

const AddressTypeCheckbox = ({
  getKeyInDigitalLayer,
  hasResidencialAddress,
  onChange,
  intl,
  value,
  isDestinationCountrySelected,
  hasPostcodesEnabled,
}) => {
  const addressTypeTrackingKeyPath = getKeyInDigitalLayer(
    "spotShipment.initialSet.receiverAddressType"
  );

  return (
    <React.Fragment>
      {hasResidencialAddress && (
        <StyledAddressTypeWrapper hasPostcodesEnabled={hasPostcodesEnabled}>
          <DhlCheckbox
            name="receiverAddressType"
            dataId="receiverAddressType"
            dataTestid="receiverAddressType"
            size={Sizes.SM}
            isDisabled={!isDestinationCountrySelected}
            value={TYPES_OF_ADDRESSES.RESIDENTIAL}
            onDhlChange={onChange}
            checked={value === TYPES_OF_ADDRESSES.RESIDENTIAL}
            dataTracking={addressTypeTrackingKeyPath}
            label={intl.formatMessage({
              id: `${COPY_ID_PREFIX}.residentialAddress`,
            })}
          />
        </StyledAddressTypeWrapper>
      )}
    </React.Fragment>
  );
};

export default AddressTypeCheckbox;

AddressTypeCheckbox.propTypes = {
  /** Translations library  */
  intl: IntlPropType.isRequired,
  hasResidencialAddress: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOf(Object.values(TYPES_OF_ADDRESSES)),
  getKeyInDigitalLayer: PropTypes.func,
  hasPostcodesEnabled: PropTypes.bool,
  isDestinationCountrySelected: PropTypes.bool,
};

AddressTypeCheckbox.defaultProps = {
  hasResidencialAddress: false,
  onChange: () => {},
  value: TYPES_OF_ADDRESSES.BUSINESS,
  getKeyInDigitalLayer: () => {},
  isDestinationCountrySelected: false,
  hasPostcodesEnabled: false,
};
